module.exports = __webpack_public_path__ + "img/leftpic.4a5ea3ab.png";